import { AppState } from '../rootReducer';

export const isLoading = (state: AppState) => state.user.isLoading;
export const getUserInfo = (state: AppState) => state.user.userInfo;
export const isLogoutLoading = (state: AppState) => state.user.isLogoutLoading;
export const loginError = (state: AppState) => state.user.loginError;
export const getWarningTime = (state: AppState) => state.user.userInfo.country.holdingTime;
export const isWarningTimeLoading = (state: AppState) => state.user.isWarningTimeLoading;
